import { TariffCode, TariffSubcriptionStatus } from "@/interfaces/reports"
import { isProEnabled } from "@/helpers/FeatureFlagHelper"

const isPaidTariffCode = (tariffCode: TariffCode | null | undefined): boolean => {
  return tariffCode === TariffCode.REPORT || (
    isProEnabled && tariffCode === TariffCode.PRO
  )
}

const isExpiredTrialTariff = (
  tariffCode: TariffCode | null | undefined,
  tariffSubscriptionStatus: TariffSubcriptionStatus | null | undefined,
): boolean => {
  return isProEnabled
    && tariffCode === TariffCode.TRIAL
    && tariffSubscriptionStatus === TariffSubcriptionStatus.EXPIRED
}

export {
  isPaidTariffCode,
  isExpiredTrialTariff,
}
